// Bundled icon subset — Material Symbols Outlined, weight 400, FILL 0 (Final Implementation
// Authority §25.7, D-14). Each import inlines one SVG string from @material-symbols/svg-400 at
// build time, so the shipped app carries exactly these glyphs and never fetches a font.
// Result icons: Pass = check_circle · Defect = warning · Unable to Inspect = visibility_off ·
// N/A = do_not_disturb_on · AI = sparkle.
import visibility from '@material-symbols/svg-400/outlined/visibility.svg?raw';
import devices from '@material-symbols/svg-400/outlined/devices.svg?raw';
import drive_file_move from '@material-symbols/svg-400/outlined/drive_file_move.svg?raw';
import upload_file from '@material-symbols/svg-400/outlined/upload_file.svg?raw';
import help from '@material-symbols/svg-400/outlined/help.svg?raw';
import lock from '@material-symbols/svg-400/outlined/lock.svg?raw';
import lock_open from '@material-symbols/svg-400/outlined/lock_open.svg?raw';
import upload from '@material-symbols/svg-400/outlined/upload.svg?raw';
import cloud_upload from '@material-symbols/svg-400/outlined/cloud_upload.svg?raw';
import perm_media from '@material-symbols/svg-400/outlined/perm_media.svg?raw';
import receipt_long from '@material-symbols/svg-400/outlined/receipt_long.svg?raw';
import shield from '@material-symbols/svg-400/outlined/shield.svg?raw';
import credit_card from '@material-symbols/svg-400/outlined/credit_card.svg?raw';
import support_agent from '@material-symbols/svg-400/outlined/support_agent.svg?raw';
import privacy_tip from '@material-symbols/svg-400/outlined/privacy_tip.svg?raw';
import gavel from '@material-symbols/svg-400/outlined/gavel.svg?raw';
import person_off from '@material-symbols/svg-400/outlined/person_off.svg?raw';
import picture_as_pdf from '@material-symbols/svg-400/outlined/picture_as_pdf.svg?raw';
import ios_share from '@material-symbols/svg-400/outlined/ios_share.svg?raw';
import edit_calendar from '@material-symbols/svg-400/outlined/edit_calendar.svg?raw';
import schedule from '@material-symbols/svg-400/outlined/schedule.svg?raw';
import handshake from '@material-symbols/svg-400/outlined/handshake.svg?raw';
import assignment_turned_in from '@material-symbols/svg-400/outlined/assignment_turned_in.svg?raw';
import add_photo_alternate from '@material-symbols/svg-400/outlined/add_photo_alternate.svg?raw';
import mode_comment from '@material-symbols/svg-400/outlined/mode_comment.svg?raw';
import image from '@material-symbols/svg-400/outlined/image.svg?raw';
import link_off from '@material-symbols/svg-400/outlined/link_off.svg?raw';
import account_circle from '@material-symbols/svg-400/outlined/account_circle.svg?raw';
import mail from '@material-symbols/svg-400/outlined/mail.svg?raw';
import key from '@material-symbols/svg-400/outlined/key.svg?raw';
import wifi_off from '@material-symbols/svg-400/outlined/wifi_off.svg?raw';
import contract from '@material-symbols/svg-400/outlined/contract.svg?raw';
import payments from '@material-symbols/svg-400/outlined/payments.svg?raw';
import verified_user from '@material-symbols/svg-400/outlined/verified_user.svg?raw';
import swap_horiz from '@material-symbols/svg-400/outlined/swap_horiz.svg?raw';
import list_alt from '@material-symbols/svg-400/outlined/list_alt.svg?raw';
import playlist_add_check from '@material-symbols/svg-400/outlined/playlist_add_check.svg?raw';
import event from '@material-symbols/svg-400/outlined/event.svg?raw';
import add from '@material-symbols/svg-400/outlined/add.svg?raw';
import add_a_photo from '@material-symbols/svg-400/outlined/add_a_photo.svg?raw';
import add_home_work from '@material-symbols/svg-400/outlined/add_home_work.svg?raw';
import apartment from '@material-symbols/svg-400/outlined/apartment.svg?raw';
import arrow_back from '@material-symbols/svg-400/outlined/arrow_back.svg?raw';
import arrow_drop_down from '@material-symbols/svg-400/outlined/arrow_drop_down.svg?raw';
import check from '@material-symbols/svg-400/outlined/check.svg?raw';
import check_circle from '@material-symbols/svg-400/outlined/check_circle.svg?raw';
import checklist from '@material-symbols/svg-400/outlined/checklist.svg?raw';
import chevron_right from '@material-symbols/svg-400/outlined/chevron_right.svg?raw';
import close from '@material-symbols/svg-400/outlined/close.svg?raw';
import cloud_done from '@material-symbols/svg-400/outlined/cloud_done.svg?raw';
import cloud_off from '@material-symbols/svg-400/outlined/cloud_off.svg?raw';
import deleteIcon from '@material-symbols/svg-400/outlined/delete.svg?raw';
import description from '@material-symbols/svg-400/outlined/description.svg?raw';
import do_not_disturb_on from '@material-symbols/svg-400/outlined/do_not_disturb_on.svg?raw';
import drag_indicator from '@material-symbols/svg-400/outlined/drag_indicator.svg?raw';
import edit from '@material-symbols/svg-400/outlined/edit.svg?raw';
import error from '@material-symbols/svg-400/outlined/error.svg?raw';
import grid_view from '@material-symbols/svg-400/outlined/grid_view.svg?raw';
import home_work from '@material-symbols/svg-400/outlined/home_work.svg?raw';
import hourglass_empty from '@material-symbols/svg-400/outlined/hourglass_empty.svg?raw';
import info from '@material-symbols/svg-400/outlined/info.svg?raw';
import keyboard_arrow_down from '@material-symbols/svg-400/outlined/keyboard_arrow_down.svg?raw';
import keyboard_arrow_up from '@material-symbols/svg-400/outlined/keyboard_arrow_up.svg?raw';
import language from '@material-symbols/svg-400/outlined/language.svg?raw';
import link from '@material-symbols/svg-400/outlined/link.svg?raw';
import login from '@material-symbols/svg-400/outlined/login.svg?raw';
import logout from '@material-symbols/svg-400/outlined/logout.svg?raw';
import menu from '@material-symbols/svg-400/outlined/menu.svg?raw';
import more_vert from '@material-symbols/svg-400/outlined/more_vert.svg?raw';
import open_in_full from '@material-symbols/svg-400/outlined/open_in_full.svg?raw';
import pending from '@material-symbols/svg-400/outlined/pending.svg?raw';
import person from '@material-symbols/svg-400/outlined/person.svg?raw';
import photo_camera from '@material-symbols/svg-400/outlined/photo_camera.svg?raw';
import photo_library from '@material-symbols/svg-400/outlined/photo_library.svg?raw';
import save from '@material-symbols/svg-400/outlined/save.svg?raw';
import search from '@material-symbols/svg-400/outlined/search.svg?raw';
import settings from '@material-symbols/svg-400/outlined/settings.svg?raw';
import sticky_note_2 from '@material-symbols/svg-400/outlined/sticky_note_2.svg?raw';
import sync from '@material-symbols/svg-400/outlined/sync.svg?raw';
import sync_problem from '@material-symbols/svg-400/outlined/sync_problem.svg?raw';
import tune from '@material-symbols/svg-400/outlined/tune.svg?raw';
import visibility_off from '@material-symbols/svg-400/outlined/visibility_off.svg?raw';
import warning from '@material-symbols/svg-400/outlined/warning.svg?raw';
import zoom_in from '@material-symbols/svg-400/outlined/zoom_in.svg?raw';
// Round 1 (Mobile M00–M05): area-kind tiles, list / layout actions, scan and status glyphs.
import add_circle from '@material-symbols/svg-400/outlined/add_circle.svg?raw';
import arrow_downward from '@material-symbols/svg-400/outlined/arrow_downward.svg?raw';
import arrow_forward from '@material-symbols/svg-400/outlined/arrow_forward.svg?raw';
import arrow_upward from '@material-symbols/svg-400/outlined/arrow_upward.svg?raw';
import bathtub from '@material-symbols/svg-400/outlined/bathtub.svg?raw';
import bed from '@material-symbols/svg-400/outlined/bed.svg?raw';
import block from '@material-symbols/svg-400/outlined/block.svg?raw';
import bolt from '@material-symbols/svg-400/outlined/bolt.svg?raw';
import category from '@material-symbols/svg-400/outlined/category.svg?raw';
import center_focus_strong from '@material-symbols/svg-400/outlined/center_focus_strong.svg?raw';
import chair from '@material-symbols/svg-400/outlined/chair.svg?raw';
import construction from '@material-symbols/svg-400/outlined/construction.svg?raw';
import cottage from '@material-symbols/svg-400/outlined/cottage.svg?raw';
import done_all from '@material-symbols/svg-400/outlined/done_all.svg?raw';
import edit_note from '@material-symbols/svg-400/outlined/edit_note.svg?raw';
import download from '@material-symbols/svg-400/outlined/download.svg?raw';
import mic from '@material-symbols/svg-400/outlined/mic.svg?raw';
import undo from '@material-symbols/svg-400/outlined/undo.svg?raw';
import crop_square from '@material-symbols/svg-400/outlined/crop_square.svg?raw';
import circle from '@material-symbols/svg-400/outlined/circle.svg?raw';
import arrow_outward from '@material-symbols/svg-400/outlined/arrow_outward.svg?raw';
import radio_button_unchecked from '@material-symbols/svg-400/outlined/radio_button_unchecked.svg?raw';
import format_list_bulleted from '@material-symbols/svg-400/outlined/format_list_bulleted.svg?raw';
import fact_check from '@material-symbols/svg-400/outlined/fact_check.svg?raw';
import filter_list from '@material-symbols/svg-400/outlined/filter_list.svg?raw';
import foundation from '@material-symbols/svg-400/outlined/foundation.svg?raw';
import garage from '@material-symbols/svg-400/outlined/garage.svg?raw';
import health_and_safety from '@material-symbols/svg-400/outlined/health_and_safety.svg?raw';
import history from '@material-symbols/svg-400/outlined/history.svg?raw';
import hvac from '@material-symbols/svg-400/outlined/hvac.svg?raw';
import inventory_2 from '@material-symbols/svg-400/outlined/inventory_2.svg?raw';
import kitchen from '@material-symbols/svg-400/outlined/kitchen.svg?raw';
import layers from '@material-symbols/svg-400/outlined/layers.svg?raw';
import meeting_room from '@material-symbols/svg-400/outlined/meeting_room.svg?raw';
import photo from '@material-symbols/svg-400/outlined/photo.svg?raw';
import play_arrow from '@material-symbols/svg-400/outlined/play_arrow.svg?raw';
import plumbing from '@material-symbols/svg-400/outlined/plumbing.svg?raw';
import priority_high from '@material-symbols/svg-400/outlined/priority_high.svg?raw';
import restart_alt from '@material-symbols/svg-400/outlined/restart_alt.svg?raw';
import roofing from '@material-symbols/svg-400/outlined/roofing.svg?raw';
import rule from '@material-symbols/svg-400/outlined/rule.svg?raw';
import stairs from '@material-symbols/svg-400/outlined/stairs.svg?raw';
import stop_circle from '@material-symbols/svg-400/outlined/stop_circle.svg?raw';
import storage from '@material-symbols/svg-400/outlined/storage.svg?raw';
import summarize from '@material-symbols/svg-400/outlined/summarize.svg?raw';
import task_alt from '@material-symbols/svg-400/outlined/task_alt.svg?raw';
import water_heater from '@material-symbols/svg-400/outlined/water_heater.svg?raw';
import yard from '@material-symbols/svg-400/outlined/yard.svg?raw';
import draw from '@material-symbols/svg-400/outlined/draw.svg?raw';
import home from '@material-symbols/svg-400/outlined/home.svg?raw';
import auto_awesome_mosaic from '@material-symbols/svg-400/outlined/auto_awesome_mosaic.svg?raw';
import flag from '@material-symbols/svg-400/outlined/flag.svg?raw';
import remove from '@material-symbols/svg-400/outlined/remove.svg?raw';
import psychology from '@material-symbols/svg-400/outlined/psychology.svg?raw';
import zoom_out from '@material-symbols/svg-400/outlined/zoom_out.svg?raw';
import fit_screen from '@material-symbols/svg-400/outlined/fit_screen.svg?raw';
import refresh from '@material-symbols/svg-400/outlined/refresh.svg?raw';
import playlist_add from '@material-symbols/svg-400/outlined/playlist_add.svg?raw';
import notes from '@material-symbols/svg-400/outlined/notes.svg?raw';
import lightbulb from '@material-symbols/svg-400/outlined/lightbulb.svg?raw';
import question_mark from '@material-symbols/svg-400/outlined/question_mark.svg?raw';
import pending_actions from '@material-symbols/svg-400/outlined/pending_actions.svg?raw';
import add_task from '@material-symbols/svg-400/outlined/add_task.svg?raw';
import chat_bubble from '@material-symbols/svg-400/outlined/chat_bubble.svg?raw';
import badge from '@material-symbols/svg-400/outlined/badge.svg?raw';
// 2026-10-20: the web version's notice on Home.
// 2026-10-20: an unfinished inspection moves to another device by file (devices · drive_file_move · upload_file).
import computer from '@material-symbols/svg-400/outlined/computer.svg?raw';

// AI accent ✦ (02 / 03 / 04): Material `auto_awesome`. The SVG package does not ship this glyph,
// so it is inlined from Material Icons (Apache-2.0) on the same 24px grid — still the bundled
// subset, still no runtime fetch.
const sparkle =
  '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24"><path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"/></svg>';

export const ICONS = Object.freeze({
  visibility,
  devices,
  drive_file_move,
  upload_file,
  help,
  lock,
  lock_open,
  upload,
  cloud_upload,
  perm_media,
  receipt_long,
  shield,
  credit_card,
  support_agent,
  privacy_tip,
  gavel,
  person_off,
  picture_as_pdf,
  ios_share,
  edit_calendar,
  schedule,
  handshake,
  assignment_turned_in,
  add_photo_alternate,
  mode_comment,
  image,
  link_off,
  account_circle,
  computer,
  mail,
  key,
  wifi_off,
  contract,
  payments,
  verified_user,
  swap_horiz,
  list_alt,
  playlist_add_check,
  event,
  add,
  add_a_photo,
  add_home_work,
  apartment,
  arrow_back,
  arrow_drop_down,
  check,
  check_circle,
  checklist,
  chevron_right,
  close,
  cloud_done,
  cloud_off,
  delete: deleteIcon,
  description,
  do_not_disturb_on,
  drag_indicator,
  edit,
  error,
  grid_view,
  home_work,
  hourglass_empty,
  info,
  keyboard_arrow_down,
  keyboard_arrow_up,
  language,
  link,
  login,
  logout,
  menu,
  more_vert,
  open_in_full,
  pending,
  person,
  photo_camera,
  photo_library,
  save,
  search,
  settings,
  sparkle,
  sticky_note_2,
  sync,
  sync_problem,
  tune,
  visibility_off,
  warning,
  zoom_in,
  add_circle,
  arrow_downward,
  arrow_forward,
  arrow_upward,
  bathtub,
  bed,
  block,
  bolt,
  category,
  center_focus_strong,
  chair,
  construction,
  cottage,
  done_all,
  edit_note,
  download,
  mic,
  undo,
  crop_square,
  circle,
  arrow_outward,
  radio_button_unchecked,
  format_list_bulleted,
  fact_check,
  filter_list,
  foundation,
  garage,
  health_and_safety,
  history,
  hvac,
  inventory_2,
  kitchen,
  layers,
  meeting_room,
  photo,
  play_arrow,
  plumbing,
  priority_high,
  restart_alt,
  roofing,
  rule,
  stairs,
  stop_circle,
  storage,
  summarize,
  task_alt,
  water_heater,
  yard,
  draw,
  home,
  auto_awesome_mosaic,
  flag,
  remove,
  psychology,
  zoom_out,
  fit_screen,
  refresh,
  playlist_add,
  notes,
  lightbulb,
  question_mark,
  pending_actions,
  add_task,
  chat_bubble,
  badge
});

export type IconName = keyof typeof ICONS;

export const ICON_NAMES = Object.freeze(Object.keys(ICONS) as IconName[]);
